import { API_URL } from "../../config/connect";

async function getNotification({ service, id }) {
    try {
        const response = await fetch(`${API_URL}/api/v1/notifications/${service}/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (!response.ok) {
            throw new Error(`Error fetching notifications: ${response.statusText}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error in getNotifications:", error);
        return [];
    }
}

export { getNotification };